import misRutas from 'vue-routes-generator'
import Main from './main'
import Listados from './components/listados/listados'
import Informes from './components/informes/informes'
import Vacaciones from './components/vacaciones/visualizar'

export default {
	install: Vue => {
		misRutas.route('/main').child('gestion-jornada', {
			name: 'Gestión de jornada',
			component: Main
		})

		misRutas.route('/main').child('gestion-jornada').child('registros', {
			name: 'Listado de jornadas',
			component: Listados
		})

		misRutas.route('/main').child('gestion-jornada').child('informes', {
			name: 'Informes de jornadas',
			component: Informes
		})

		misRutas.route('/main').child('vacaciones', {
			name: 'Vacaciones',
			component: Vacaciones
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-jornada/vue/index.js